const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="container mx-auto p-4">
        <ul className="flex justify-center items-center space-x-4 mx-auto list-none">
          <li>
            <a
              href="/"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              Home
            </a>
          </li>
          <li>
            <a
              href="#about"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              About
            </a>
          </li>
          <li>
            <a
              href="#projects"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              Projects
            </a>
          </li>
          <li>
            <a
              href="#skills"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              Skills
            </a>
          </li>
          <li>
            <a
              href="#testimonials"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              Testimonials
            </a>
          </li>
          <li>
            <a
              href="#contact"
              className="text-lg text-yellow-400 hover:text-indigo-600"
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
